export default "/_next/static/chunks/fonts/WhitneySSm-Book-Pro_Web-63b04eb47ce7c7db79870d0a95b3b2af.woff";